import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../services/api";
import Constants from "../../services/constants";
import { showToast } from "./toastSlice";

const initialState = {
    homeItems: {},
    loading: false,
    error: null,
};

export const fetchHomeItems = createAsyncThunk("homeItems/fetchItems", async ({ setIsLoading }, { dispatch }) => {
    try {
        setIsLoading(true);
        const res = await api("get", Constants.END_POINT.HOME_DETAILS);
        if (res.success && res.data) {
            return res.data;
        } else {
            dispatch(showToast({ severity: "error", summary: res.message }));
            return Promise.reject(res.message);
        }
    } catch (error) {
        dispatch(showToast({ severity: "error", summary: error.message }));
        return Promise.reject("An12 error occurred.");
    } finally {
        setIsLoading(false);
    }
});

const homeSlice = createSlice({
    name: "home",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchHomeItems.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchHomeItems.fulfilled, (state, action) => {
                state.loading = false;
                state.homeItems = action.payload;
            })
            .addCase(fetchHomeItems.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default homeSlice.reducer;
